const useSearchEngineVisable = (data) => { 
    
    let isPageVisibleToSearchEngines = data === null ? true : data.isPageVisibleToSearchEngines;
    let VisableResponse = (isPageVisibleToSearchEngines == null || !isPageVisibleToSearchEngines) ? 'noindex, nofollow' : 'index, follow';
    return [VisableResponse];
   
}
export default useSearchEngineVisable;